import React from 'react';
import Header from '@di-shared/features/common/Header';
import HeaderBackButton from '@di-shared/features/common/HeaderBackButton';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import DiagExchangeHistory, {
  CONSUMABLE_TAB_ALL,
  ConsumableTabServerType,
} from '@di-shared/features/diag/exchange/history/DiagExchangeHistory';
import useUrlQueryStore from '@shared/useUrlQueryStore';

interface DiagExchangeHistoryPageProps {
  vin: string;
}

function DiagExchangeHistoryPage({vin}: DiagExchangeHistoryPageProps) {
  const [currentTabFilter, setCurrentTabFilter] = useUrlQueryStore<{tab: ConsumableTabServerType}>('exchangehistory', {
    tab: CONSUMABLE_TAB_ALL,
  });
  const {t} = useInferableTranslation();

  return (
    <div className="wrap">
      <Header left={<HeaderBackButton />}>
        <h1 className="title_xsmall_b nav_center_title">{t('T30588')}</h1>
      </Header>
      <main
        id="content"
        className="content page_car_management"
      >
        <DiagExchangeHistory
          vin={vin}
          selectedTab={currentTabFilter.tab}
          onUpdateTabFilter={(tab: ConsumableTabServerType) => setCurrentTabFilter({tab}, true)}
        />
      </main>
    </div>
  );
}

export default DiagExchangeHistoryPage;
